const foundingSourcesAvaliableModel = ()=> {
    return {
        foundingSourcesAvaliable: [
            {
                mapTo: 'fundingSource.isVrs',
                label: 'VRS'
            },
            {
                mapTo: 'fundingSource.isDdWaiver',
                label: 'DD Waiver'
            },
            {
                mapTo: 'fundingSource.isCadiWaiver',
                label: 'CADI Waiver'
            },
            {
                mapTo: 'fundingSource.isBiWaiver',
                label: 'BI Waiver'
            },
            {
                mapTo: 'fundingSource.isCountyFunded',
                label: 'County Funded'
            },
            {
                mapTo: 'fundingSource.isSsb',
                label: 'SSB'
            },
            {
                mapTo: 'fundingSource.isSchoolFunded',
                label: 'School Funded'
            },
            {
                mapTo: 'fundingSource.isCeed',
                label: 'CEED'
            }
        ]
    };
};

export default foundingSourcesAvaliableModel;